export const withURLParam = (pageURL, paramKey, paramEntry, fragment) => {
    const modifiedURL = new URL(pageURL);
    const search = new URLSearchParams(modifiedURL.search);
    search.set(paramKey, paramEntry);
    modifiedURL.search = search.toString();
    if (fragment) {
        modifiedURL.hash = fragment;
    }
    return modifiedURL;
};
export const removeURLParams = (pageURL, paramKeys) => {
    const modifiedURL = new URL(pageURL);
    const updatedParams = new URLSearchParams(modifiedURL.search);
    for (const paramKey of paramKeys) {
        updatedParams.delete(paramKey);
    }
    modifiedURL.search = updatedParams.toString();
    return modifiedURL;
};
//# sourceMappingURL=paramUtils.js.map